import { useRef, useEffect, Suspense } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { Float, Environment, useGLTF } from '@react-three/drei'
import * as THREE from 'three'

import modelPath from '../assets/skull.glb'

const mouse = new THREE.Vector2(0, 0)

const DRACO_CDN = 'https://www.gstatic.com/draco/versioned/decoders/1.5.6/'

const GoldModel = () => {
  const { scene } = useGLTF(modelPath, DRACO_CDN)
  const meshRef = useRef()
  const targetRotation = useRef({ x: 0, y: 0 })
  const { gl } = useThree()

  // Apply gold material to all meshes
  scene.traverse((child) => {
    if (child.isMesh) {
      child.material.color.set('#DAA520')
      child.material.metalness = 0.95
      child.material.roughness = 0.18
      child.material.envMapIntensity = 1.8
    }
  })

  useEffect(() => {
    const handleMouseMove = (e) => {
      const rect = gl.domElement.getBoundingClientRect()
      // Normalize to -1..1 relative to canvas center
      mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1
      mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [gl])

  useFrame(() => {
    if (!meshRef.current) return

    // Map mouse position to rotation (limited range for natural look)
    targetRotation.current.y = mouse.x * 0.6
    targetRotation.current.x = -mouse.y * 0.3

    // Smooth lerp towards target (like MetaMask fox)
    meshRef.current.rotation.y += (targetRotation.current.y - meshRef.current.rotation.y) * 0.08
    meshRef.current.rotation.x += (targetRotation.current.x - meshRef.current.rotation.x) * 0.08
  })

  return (
    <group ref={meshRef}>
      <primitive object={scene} scale={3.2} position={[0, 0, 0]} />
    </group>
  )
}

const GoldCrystal3D = () => {
  return (
    <div className="landing__crystal">
      <Canvas
        camera={{ position: [0, 0, 10], fov: 48 }}
        dpr={[1, 2]}
        gl={{ antialias: true, alpha: true }}
        style={{ background: 'transparent' }}
      >
        <Suspense fallback={null}>
          <ambientLight intensity={0.4} />
          <directionalLight position={[5, 5, 5]} intensity={1.5} color="#FFF8DC" />
          <directionalLight position={[-3, -2, -3]} intensity={0.5} color="#B8960C" />
          <pointLight position={[0, 3, 0]} intensity={1} color="#FFD700" distance={10} />

          <Float
            speed={1.5}
            rotationIntensity={0.2}
            floatIntensity={0.6}
            floatingRange={[-0.15, 0.15]}
          >
            <GoldModel />
          </Float>

          <Environment preset="city" environmentIntensity={0.8} />
        </Suspense>
      </Canvas>
    </div>
  )
}

export default GoldCrystal3D
